/**
 * Browser page location for access logging (SPA URL, not the API endpoint).
 * @returns {{ http_host: string, request_uri: string, query_string: string }}
 */
export function getBrowserAccessContext() {
  if (typeof window === 'undefined' || !window.location) {
    return {
      http_host: '',
      request_uri: '',
      query_string: '',
    }
  }

  const { host, pathname, search } = window.location

  return {
    http_host: host || '',
    request_uri: `${pathname || ''}${search || ''}`,
    query_string: search ? search.replace(/^\?/, '') : '',
  }
}
